import React, { useEffect, useState } from 'react'
import ConfigLayout from '../Layouts/ConfigLayout'
import isAuthenticated from '../../routes/PrivateRoute'
import { Alert, Button, Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getAllHealthSystems, createHealthSystem } from '../../redux/actions/healthSystem'
import { Link } from 'react-router-dom'
import HealthSystemModal from '../Modals/HealthSystemModal'

const Configurator = () => {
  const [show, setShow] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const dispatch = useDispatch()

  const { getHealthSystemsState, healthSystems, createHealthSystemState } = useSelector((state) => ({
    healthSystems: state.healthSystem.healthSystems,
    getHealthSystemsState: state.healthSystem.getHealthSystems,
    createHealthSystemState: state.healthSystem.createHealthSystem
  })) 

  useEffect(() => {
    dispatch(getAllHealthSystems())
  }, [])

  useEffect(() => {
    if (getHealthSystemsState.error !== false) {
      setShow(true)
    }
  }, [getHealthSystemsState.error])

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleSubmit = (values) => {
    dispatch(createHealthSystem(values))
  }

  useEffect(() => {
    if (createHealthSystemState.success) {
      setShowModal(false)
    }
  }, [createHealthSystemState.success])

  return (
    <ConfigLayout showUser>
      <h2>Configurator</h2>
      <Container fluid className='border p-2 configurator'>
        <Row>
          <Col xs={2}>
            <h3 className='slate-gray'>Clients</h3>
          </Col>
          <Col xs='auto'>
            <Button onClick={handleOpenModal}>+ Add New Client</Button>
          </Col>
        </Row>
        <Row className='mt-2'>
          <Col xs={12}>
            {
              getHealthSystemsState.error !== false ? (
                <Alert show={show} onClose={() => setShow(false)} variant='danger'>
                  {getHealthSystemsState.error.message}
                </Alert>
              ) : healthSystems.length > 0 ? (
                <>
                  {
                    healthSystems.map((healthSystem) => (
                      <Row key={healthSystem.healthSystemId} className='mt-2'>
                        <Col xs={1} className='mt-1 text-center'>
                          {healthSystem.active ? 'Active' : 'Inactive'}
                        </Col>
                        <Col xs={4}>
                          <h5><Link to={`/health-system/${healthSystem.tenant}`}>{healthSystem.name}</Link></h5>
                        </Col>
                        <Col xs={2}>
                          {healthSystem.epicVersion}
                        </Col>
                        <Col xs={3}>
                          {healthSystem.tenant}
                        </Col>
                      </Row>
                    ))
                  }
                </>
              ) : 'No clients'
            }
          </Col>
        </Row>
      </Container>
      <HealthSystemModal 
        show={showModal} 
        onClose={handleCloseModal}
        state={createHealthSystemState}
        onSubmit={handleSubmit}
      />
    </ConfigLayout>
  )
}

export default isAuthenticated(Configurator)